import type { ProgressCircleIndeterminateSize } from '@/app/components/atoms/ProgressCircleIndeterminate'

/** Tamaño del spinner en el overlay de pantalla completa (48px). */
export const SPINNER_SIZE: ProgressCircleIndeterminateSize = 'l'
